import React, { Component } from "react";
import ErrorBoundary from "../../hoc/errorBoundary/error.js";
import classes from "./home.module.scss";
import Title from "../../components/home/title/title.js";
import RiverInfo from "../../components/home/river_info/river_info.js";
import BasinMap from "../../components/home/map/map.js";

function Home(props) {
  return (
    <ErrorBoundary>
      <main className={classes.main}>
        <div className={classes.wrapper}>
          <Title />
          <section className={classes.map}>
            <BasinMap />
            <RiverInfo />
          </section>
        </div>
      </main>
    </ErrorBoundary>
  );
}

export default Home;
